<template>
    <div>
        <!-- 页面导航栏 -->
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item> <i class="el-icon-document"></i> 账户管理 </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 主容器 -->
        <div class="container">
            <!-- 搜索区域 -->
            <div class="handle-box">
                <el-input v-model="name" placeholder="请输入账户编号" class="handle-input mr10"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('common.search') }}</el-button>
                <el-button type="" style="float: right" @click="showImpotDialog = true">导入</el-button>
                <el-button style="float:right" type="primary" v-if="perData.allow_add == 1" @click="handleAdd">{{ $t('common.add') }}</el-button>

            </div>
            <!-- 数据表格 -->
            <el-table :data="tableData" border stripe class="table" ref="multipleTable" header-cell-class-name="table-header">
                <!-- 表格列定义 -->
                <el-table-column type="index" label="序号" width="90" align="center"></el-table-column>
                <el-table-column prop="bank_no" label="账户编号" align="center"></el-table-column>
                <el-table-column prop="bank_name" label="账户名称" align="center"></el-table-column>
                <el-table-column v-if="systemSet.isstores == 1" prop="store_no" label="所属门店编号" align="center"></el-table-column>
                <el-table-column v-if="systemSet.isstores == 1" prop="store_name" label="所属门店名称" align="center"></el-table-column>
                <!-- 启用状态列 -->
                <el-table-column label="启用" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <!-- 默认状态列 -->
                <el-table-column label="默认" align="center">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isdefault" :active-value="1" :inactive-value="0"
                                   @change="tableDatastates(scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>

                <el-table-column prop="bankaccountname" label="开户姓名" align="center"></el-table-column>
                <el-table-column prop="accountname" label="开户银行" align="center"></el-table-column>
                <el-table-column prop="accountnumber" label="银行卡号" align="center"></el-table-column>
                <el-table-column prop="remark" :label="$t('common.remark')" align="center"></el-table-column>

                <!-- 操作列（仅允许编辑时显示） -->
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-if="perData.allow_edit == 1">{{ $t('common.edit') }}</el-button>
                        <el-button type="danger" plain @click="handleDelete(scope.row)" v-if="perData.allow_dele == 1">{{ $t('common.delete') }}</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!-- 分页组件 -->
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :current-page="pageIndex"
                    :page-sizes="[10, 20, 30]"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                    @size-change="pageSizeChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑对话框 -->
        <el-dialog :title="$t('common.edit')" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <el-form ref="form" :model="editForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="账户编号">
                    <el-input v-model="editForm.bank_no" disabled></el-input>
                </el-form-item>
                <el-form-item label="账户名称">
                    <el-input v-model="editForm.bank_name"></el-input>
                </el-form-item>
                <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                    <el-select
                        v-model="editForm.store_no"
                        clearable
                        filterable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in pullData.store"
                            :key="index"
                            :label="item.store_name"
                            :value="item.store_no"
                        >
                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开户姓名">
                    <el-input v-model="editForm.bankaccountname"></el-input>
                </el-form-item>
                <el-form-item label="开户银行">
                    <el-input v-model="editForm.accountname"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号">
                    <el-input v-model="editForm.accountnumber"></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="editForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="editFormData">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 新增对话框 -->
        <el-dialog :title="$t('common.add')" :visible.sync="addDialogVisible" width="30%" :before-close="handleAddClose">
            <el-form ref="addForm" :model="addForm" label-width="120px">
                <!-- 表单字段 -->
                <el-form-item label="账户编号">
                    <el-input v-model="addForm.bank_no"></el-input>
                </el-form-item>
                <el-form-item label="账户名称">
                    <el-input v-model="addForm.bank_name"></el-input>
                </el-form-item>
                <el-form-item label="所属门店" prop="store_no" v-if="systemSet.isstores == 1">
                    <el-select
                        v-model="addForm.store_no"
                        clearable
                        filterable
                        default-first-option
                        placeholder="请选择"
                    >
                        <el-option
                            v-for="(item, index) in pullData.store"
                            :key="index"
                            :label="item.store_name"
                            :value="item.store_no"
                        >
                            <span style="margin-left: 10px">{{ item.store_name }}</span>
                            <span style="float: left; color: #8492a6; font-size: 13px">{{ item.store_no }}</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="开户姓名">
                    <el-input v-model="addForm.bankaccountname"></el-input>
                </el-form-item>
                <el-form-item label="开户银行">
                    <el-input v-model="addForm.accountname"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号">
                    <el-input v-model="addForm.accountnumber"></el-input>
                </el-form-item>
                <el-form-item :label="$t('common.remark')">
                    <el-input v-model="addForm.remark"></el-input>
                </el-form-item>
            </el-form>
            <!-- 对话框底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleAddClose">取 消</el-button>
                <el-button type="primary" @click="saveAdd">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 导入明细弹窗 -->
        <el-dialog title="导入账户" :visible.sync="showImpotDialog" width="55%" :close="resetImportDialog">
            <div class="importDialogCenter">
                <!-- 左侧：下载导入模板 -->
                <div class="centerItem leftItem" v-loading="templateLoading" @click="outTem">
                    <i class="el-icon-download avatar-uploader-icon"></i>
                    <p class="itemText">点击下载模板</p>
                </div>
                <!-- 右侧：拖拽上传文件 -->
                <div class="centerItem">
                    <el-upload
                        ref="importUpload"
                        class="upload-demo"
                        drag
                        :action="importUploadUrl"
                        :headers="headers"
                        accept=".xls,.xlsx"
                        :limit="1"
                        :show-file-list="false"
                        :disabled="importLoading"
                        :before-upload="beforeImportUpload"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :on-exceed="uploadExceed"
                        style="width: 100%"
                    >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                    </el-upload>
                </div>
            </div>
            <div class="importTip">
                <i class="el-icon-document"></i> 支持拓展名：.xls、.xlsx，文件大小不超过 10MB
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showImpotDialog = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
// 导入 API 接口
import {
    apiGetBankStatusList,
    apiCurrentPermisson,
    apiBankManagePull,
    apiAddBankData,
    apiUpdateBankStatus,
    apiUpdateBankData,
    apiDeleteBankData,
    exportTemplate_BankManage
} from '@/request/api';
export default {
    name: 'basetable',
    data() {
        return {
            addForm: {},
            editForm: {},
            dialogVisible: false,
            addDialogVisible: false,
            showImpotDialog: false,
            importLoading: false, // 导入上传中标识
            templateLoading: false, // 模板下载中标识
            headers: {},
            pullData: [],
            name: '',
            pageIndex: 1,
            pageSize: 10,
            tableData: [],
            perData: '',
            pageTotal: 0,
            systemSet: JSON.parse(localStorage.getItem('systemSet'))
        };
    },
    computed: {
        // 导入上传地址
        importUploadUrl() {
            return this.$baseURL + 'importExcelData_BankManage';
        }
    },
    mounted() {
        // 组件挂载时加载数据
        let token = sessionStorage.getItem('userToken');
        this.headers.Authorization = 'Bearer ' + token;
        this.getPull();
        this.getData();
        this.getPermission();
    },
    activated() {
        // keep-alive 缓存组件激活时刷新数据
        this.getPull();
        this.getData();
        this.getPermission();
    },
    methods: {
        getPull() {
            apiBankManagePull().then(res => {
                if (res.code == 2000) {
                    this.pullData = res.data;
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        // 编辑操作----------------------------------------------------------------------------------------------------
        // 编辑按钮点击事件
        handleEdit(row) {
            this.dialogVisible = true;
            // 创建 row 的深拷贝，避免直接引用原始数据
            this.editForm = JSON.parse(JSON.stringify(row));
        },
        // 提交编辑表单
        editFormData() {
            apiUpdateBankData(this.editForm).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg); // 成功提示
                    this.getData(); // 刷新表格数据
                    this.handleClose(); // 关闭对话框
                } else {
                    this.$message.error(res.data.info);// 失败提示
                }
            });
        },
        // 关闭编辑对话框
        handleClose() {
            this.editForm = {};// 清空表单数据
            this.dialogVisible = false; // 隐藏对话框
        },
        //添加----------------------------------------------------------------------------------------------------
        handleAdd() {
            this.addDialogVisible = true;
            this.addForm = {};

            this.$nextTick(() => {
                if (this.pullData.store) {
                    const defaultStore = this.pullData.store.find((store) => store.isdefault == 1);
                    this.$set(this.addForm, 'store_no', defaultStore ? defaultStore.store_no : '');
                }
            });
        },
        saveAdd() {
            apiAddBankData(this.addForm).then(res => {
                if (res.code == 2000) {
                    this.$message({ message: '添加成功', type: 'success' });
                    this.addDialogVisible = false;
                    this.getData();
                } else {
                    this.$message.error(res.data.info);
                }
            });
        },
        handleAddClose() {
            this.addForm = {};
            this.addDialogVisible = false;
        },
        // 删除操作----------------------------------------------------------------------------------------------------
        handleDelete(row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    let data = {
                    bank_no: row.bank_no, // 账户编号
                };
                    apiDeleteBankData(data).then(res => {
                        if (res.code == 2000) {
                            this.$message({ message: '删除成功', type: 'success' });
                            this.getData();
                        } else {
                            this.$message.error(res.data.info);
                        }
                    });
                })
                .catch(() => {});
        },

        // 锁定状态切换事件
        tableDatastates(row) {
            let data = {
                bank_no: row.bank_no, // 账户编号
                store_no: row.store_no, // 门店编号
                islock: row.islock, // 锁定状态（1=锁定，0=解锁）
                status: row.status, // 启用状态（1=启用，0=停用）
                isdefault: row.isdefault // 默认状态（1=是，0=否）
            };
            apiUpdateBankStatus(data).then((res) => {
                if (res.code === 2000) {
                    this.$message.success(res.msg);// 成功提示
                } else {
                    this.$message.error(res.data.info); // 失败提示
                }
                this.getData(); // 刷新表格数据
            });
        },
        // 获取列表信息
        getData() {
            this.$load.show(); // 显示加载动画
            apiGetBankStatusList({
                page: this.pageIndex, // 当前页码
                page_size: this.pageSize, // 每页数量
                seek: this.name// 搜索关键字
            }).then((res) => {
                if (res.code == 2000) {
                    this.tableData = res.data.data;// 赋值表格数据
                    this.pageTotal = res.data.count;// 赋值总数据量
                } else {
                    this.$message.error(res.data.msg);// 错误提示
                }
            });
            this.$load.close(); // 关闭加载动画
        },
        //获得页面按钮的权限（添加，修改，删除）
        getPermission() {
            apiCurrentPermisson({
                id: '172' // 权限ID（需根据实际ID调整）
            }).then((res) => {
                if (res.code == 2000) {
                    this.perData = res.data;// 赋值权限数据
                } else {
                    this.$message.error(res.msg); // 错误提示
                }
            });
        },
        // 搜索按钮点击事件
        handleSearch() {
            this.pageIndex = 1;// 重置为第一页
            this.getData();// 重新加载数据
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val; // 更新当前页码
            this.getData();// 重新加载数据
        },
        pageSizeChange(val) {
            this.pageSize = val; // 更新每页数量
            this.getData(); // 重新加载数据
        },
        // 导入相关----------------------------------------------------------------------------------------------------
        // 上传前校验：仅支持 .xls/.xlsx 文件，大小不超过 10MB
        beforeImportUpload(file) {
            const isExcel = /\.xlsx?$/i.test(file.name);
            if (!isExcel) {
                this.$message.error('仅支持导入 .xls 或 .xlsx 格式的文件');
                return false;
            }
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.error('文件大小不能超过 10MB');
                return false;
            }
            this.importLoading = true; // 开始上传，开启加载状态
            return true;
        },
        // 超出文件数量限制提示（每次仅支持导入一个文件）
        uploadExceed() {
            // 上次上传的文件仍残留在内部列表中，先清空再提示
            this.clearImportFiles();
            this.$message.warning('已清空上次选择的文件，请重新选择文件导入');
        },
        // 清空上传组件内部文件列表（避免 limit=1 时残留文件导致下次选择被拦截）
        clearImportFiles() {
            if (this.$refs.importUpload) {
                this.$refs.importUpload.clearFiles();
            }
        },
        // 上传成功的钩子
        uploadSuccess(res) {
            this.importLoading = false;
            this.clearImportFiles(); // 上传完成后清空内部文件列表，支持再次导入
            if (res.code == 2000) {
                this.$message.success(res.msg);
                this.showImpotDialog = false;
                this.pageIndex = 1; // 导入成功后回到第一页
                this.getData(); // 刷新表格数据
            } else {
                // 兼容后端不同的错误返回结构，安全取值
                const errInfo = res.data && res.data.info ? (Array.isArray(res.data.info) ? res.data.info[0] : res.data.info) : res.msg;
                this.$message.error(errInfo || '导入失败');
            }
        },
        // 上传失败的钩子
        uploadError() {
            this.importLoading = false;
            this.clearImportFiles(); // 上传失败同样清空，允许重新选择文件
            this.$message.error('上传失败，请检查网络后重试');
        },
        // 导入弹窗关闭后重置状态
        resetImportDialog() {
            this.importLoading = false;
            this.clearImportFiles(); // 清空已选文件
        },
        // 下载导入模板
        outTem() {
            if (this.templateLoading) return; // 防止重复点击
            this.templateLoading = true;
            exportTemplate_BankManage({
                token: sessionStorage.getItem('userToken')
            })
                .then((response) => {
                    // 创建一个blob对象,file的一种
                    let blob = new Blob([response.data]);
                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = '账户导入模板.xls';
                    link.click();
                    window.URL.revokeObjectURL(link.href); // 释放内存
                })
                .catch(() => {
                    this.$message.error('模板下载失败，请稍后重试');
                })
                .finally(() => {
                    this.templateLoading = false;
                });
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.importDialogCenter {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start; /* 两框顶部对齐，高度均为 180px */
}
.importTip {
    margin-top: 10px;
    text-align: center;
    font-size: 12px;
    color: #909399;
}
.importDialogCenter .centerItem {
    width: 48%;
    text-align: center;
}
.importDialogCenter .centerItem /deep/ .el-upload--text {
    width: 100%;
    height: 100%;
}
.importDialogCenter .centerItem /deep/ .el-upload-dragger {
    width: 100%;
}
.importDialogCenter .leftItem {
    width: 48%;
    height: 180px;
    cursor: pointer;
    box-sizing: border-box;
    position: relative;
    border-radius: 8px;
    border: 1px dashed #97a8be;
    transition: border-color 0.3s;
}
.importDialogCenter .leftItem:hover {
    border-color: #409eff;
}
.importDialogCenter .leftItem:hover .avatar-uploader-icon,
.importDialogCenter .leftItem:hover .itemText {
    color: #409eff;
}
.importDialogCenter .leftItem .itemText {
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
    transition: color 0.3s;
}
</style>
<style>
.el-table thead {
    color: #000;
    font-weight: bold;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #ecf5ff;
}
.el-table th {
    background: #ecf5ff !important;
}
.el-dialog {
    width: 40%;
}
@media screen and (max-width: 768px) {
    .el-dialog {
        width: 100% !important;
    }
    .el-message-box {
        width: 100%;
    }
    .handle-input {
        display: block !important;
        width: 100% !important;
        margin: 10px 0;
    }
}
</style>
